





















































































import { Component, Mixins } from "vue-property-decorator";
import { getSubscribeList } from "@/api/message";
import { sleep } from "@/utils";
import DialogMixin from "@/mixins/dialog";
import { dialogCloseType } from "@/types/element";
import { Item } from "@/types/list";

@Component({
  components: {
    Edite: () => import("./component/edite"),
  },
})
export default class messageSubscribe extends Mixins(DialogMixin) {
  search = "";
  loading = false;
  close = false;
  dialogShow = "";
  tableHead = [{ name: "msgType", label: "消息类型" }];
  tableData: Item[] = [];
  dialogClose!: dialogCloseType;
  private get filterData() {
    const { tableData, search } = this;
    return tableData.filter(
      (data) =>
        !search || data.msgType.toLowerCase().includes(search.toLowerCase())
    );
  }

  mounted(): void {
    this.getSubscribeList();
  }

  async getSubscribeList(): Promise<unknown> {
    this.loading = true;
    const [err, res] = await getSubscribeList();
    if (!err && res) {
      await sleep(1000);
      this.tableData = res;
      this.loading = false;
    }
    return;
  }
  edite(row: Item): void {
    console.info(row);
    this.tableData.splice(row.$index, 1, row);
  }
  onSwitch(type: string): void {
    if (type) {
      this.dialogShow = "Edite";
    }
  }
}
